import { MAIN_STAGE } from '../main-stage';
import type { ObstacleDefinition, SetDefinition } from '../types';
import { denserTiers, inCorners } from './stage-kit';

const PUMPUI_TICKS_PER_BEAT = 14;
const MAST_RADIUS = 17;

export const PUMPUI_MASTS: readonly ObstacleDefinition[] = [
  { x: 512, y: 408, radius: MAST_RADIUS },
  { x: 804, y: 263, radius: MAST_RADIUS },
  { x: 1091, y: 414, radius: MAST_RADIUS },
  { x: 1014, y: 673, radius: MAST_RADIUS },
  { x: 669, y: 716, radius: MAST_RADIUS },
];

export const PUMPUI: SetDefinition = {
  ...MAIN_STAGE,
  tiers: denserTiers(1.1),
  id: 'pumpui',
  trackIds: ['les-ailes-de-bois'],
  name: 'Pumpui',
  style: 'Progressive',
  ticksPerBeat: PUMPUI_TICKS_PER_BEAT,
  decor: 'pumpui',
  obstacles: PUMPUI_MASTS,
  acoustics: { reverbSeconds: 1.6, wet: 0.28, lowCutHz: 160, toneHz: 7000 },
  speakers: inCorners(MAIN_STAGE.speakers),
};
